<div
  [class]="fieldAttribute.elementStyles.containerStyle"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
  [formGroup]="form"
>
  <div *ngIf="isLoading" class="spinner">
    <div class="spinner-grow text-primary load m-5" role="status" data-test-id="loading-spinner">
      <span class="sr-only"></span>
    </div>
  </div>
  <label class="form-label" [for]="fieldAttribute.id">
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
  </label>
  <div class="custom-file">
    <input
      #fileInput
      (change)="onFileChanged($event)"
      type="file"
      id="single_uploader"
      [attr.data-test-id]="fieldAttribute.elementDataTestId + '_input'"
      [multiple]="false"
      class="d-none"
    />

    <label
      class="btn btn-outline-primary me-3 form-label"
      for="single_uploader"
      role="button"
      [attr.title]="'RICH_TEXT_EDITOR_IMG_UPLOAD_BTN_LABEL' | translate"
      [attr.data-test-id]="fieldAttribute.elementDataTestId + '_label'"
    >
      {{ 'RICH_TEXT_EDITOR_IMG_UPLOAD_BTN_LABEL' | translate }}
    </label>
  </div>
  <angular-editor
    [id]="fieldAttribute.id"
    [placeholder]="fieldAttribute.backendAttribute.placeholder | translate"
    [class.is-invalid]="isFieldInvalid()"
    [formControlName]="fieldAttribute.backendAttribute.name"
    [config]="editorConfig"
    [attr.data-test-id]="fieldAttribute.elementDataTestId"
    (focus)="onFocus()"
  >
  </angular-editor>
  <div class="d-flex justify-content-between">
    <div class="d-flex flex-column">
      <small class="form-text text-secondary">{{
        'RICH_TEXT_EDITOR_RULE_HINT'
          | translate
            : {
                numberOfCharacters: MAX_LENGTH,
                numberOfImages: MAX_IMAGES
              }
      }}</small>
      <small
        [attr.data-test-id]="fieldAttribute.elementDataTestId + '-maxLength'"
        [ngClass]="'text-danger'"
        *ngIf="hasError('maxLength')"
      >
        {{ 'RICH_TEXT_EDITOR_EXCEEDED_CHARACTERS' | translate }}
      </small>
      <small
        [attr.data-test-id]="fieldAttribute.elementDataTestId + '-maxImages'"
        [ngClass]="'text-danger'"
        *ngIf="hasError('maxImages')"
      >
        {{ 'RICH_TEXT_EDITOR_EXCEEDED_IMG' | translate }}
      </small>
      <small
        *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
        class="d-flex mt-1 invalid-feedback"
        [attr.data-test-id]="fieldAttribute.errorDataTestId"
      >
        {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
      </small>
    </div>

    <div class="d-flex flex-column counters">
      <small
        [attr.data-test-id]="fieldAttribute.elementDataTestId + '-symbols-left'"
        class="form-text"
        [ngClass]="hasError('maxLength') ? 'text-danger' : 'text-secondary'"
      >
        {{ 'RICH_TEXT_EDITOR_SYMBOLS_COUNTER' | translate: { symbolsLeft: symbolsLeftCount } }}
      </small>
      <small
        [attr.data-test-id]="fieldAttribute.elementDataTestId + '-images-left'"
        class="form-text"
        [ngClass]="hasError('maxImages') ? 'text-danger' : 'text-secondary'"
      >
        {{ 'RICH_TEXT_EDITOR_IMAGES_COUNTER' | translate: { imagesLeft: imagesLeftCount } }}
      </small>
    </div>
  </div>
</div>
